export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";